import React from 'react'
import classes from "./Third.module.scss"
import img1 from "../../../assets/img/MainPage/3/1.svg"
import img2 from "../../../assets/img/MainPage/3/2.svg"
import img3 from "../../../assets/img/MainPage/3/3.svg"

const Third = () => {
    return (
        <div className={[classes.third, ""].join(" ")}>
            <div className={[classes.thirdBody, ""].join(" ")}>
                <div className={[classes.thirdRow, ""].join(" ")}>
                    <div className={[classes.thirdRowColumn, ""].join(" ")}>
                        <div className={[classes.thirdRowColumnImg, ""].join(" ")}>
                            <img src={img1} alt="" />
                        </div>
                        <p className={[classes.thirdRowColumnText, ""].join(" ")}>
                            Pawdicure
                        </p>

                    </div>
                    <div className={[classes.thirdRowColumn, ""].join(" ")}>
                        <div className={[classes.thirdRowColumnImg, ""].join(" ")}>
                            <img src={img2} alt="" />
                        </div>
                        <p className={[classes.thirdRowColumnText, ""].join(" ")}>
                            Spa Baths
                        </p>

                    </div>
                    <div className={[classes.thirdRowColumn, ""].join(" ")}>
                        <div className={[classes.thirdRowColumnImg, ""].join(" ")}>
                            <img src={img3} alt="" />
                        </div>
                        <p className={[classes.thirdRowColumnText, ""].join(" ")}>
                            Haircut of Choice
                        </p>

                    </div>
                </div>

            </div>

        </div>

    )
}

export default Third